import type {Module} from "vuex";
import type {RootState} from "@/store/types";

import home from "./page/home"

const page: Module<Record<string, never>, RootState> = {
    namespaced: true,
    actions: {
        clear(context) {

            context.dispatch("home/clear");
        }
    },
    modules: {
        home
    }
}

export default page
